import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import PageBanner from 'components/PageBanner';
import Deputies from './components/Deputies';

function DeputiesPage() {
    const { t } = useTranslation();

    return (
        <div className='deputies-page'>
            <PageBanner
                title={t('menu.ALDERMEN')}
                primaryPage={false}
                previous
            />
            <Deputies />
        </div>
    );
}

export default DeputiesPage;
